import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";

export default function LegalPage({ type }) {
  const page = CONTENT[type];
  return (
    <>
      <SEO title={`${page.title} — Pratik Teknoloji`} description={page.desc} />

      <PageHero
        badge="Yasal"
        title={page.title}
      />

      <section className="pb-24 bg-[#FDFBF7] border-t border-[#E5E5EA]">
        <div className="max-w-4xl mx-auto px-6 md:px-10 py-16">
          <article className="prose prose-lg max-w-none">
            {page.sections.map((sec, i) => (
              <div key={i} className="mb-10">
                {sec.heading && <h2 className="font-display text-2xl md:text-3xl font-bold text-[#0A0A0A] tracking-tight mt-10 mb-4">{sec.heading}</h2>}
                {sec.paragraphs?.map((p, j) => <p key={j} className="text-[#52525B] leading-relaxed mb-4">{p}</p>)}
                {sec.list && (
                  <ul className="space-y-2 my-4">
                    {sec.list.map((li, k) => (
                      <li key={k} className="flex items-start gap-3"><span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#FF3B30] flex-none"></span><span className="text-[#52525B]">{li}</span></li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </article>
        </div>
      </section>
    </>
  );
}

const CONTENT = {
  kvkk: {
    title: "KVKK Aydınlatma Metni",
    desc: "Pratik Bilişim Teknolojileri A.Ş. KVKK Aydınlatma Metni.",
    sections: [
      { paragraphs: [
        "Pratik Bilişim Teknolojileri Anonim Şirketi (\"Şirket\") olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu (\"KVKK\") kapsamında veri sorumlusu sıfatıyla; kişisel verilerinizi hukuka ve dürüstlük kurallarına uygun şekilde, işleme amaçlarıyla bağlantılı, sınırlı ve ölçülü olarak işlemekteyiz. Bu Aydınlatma Metni, kişisel verilerinizin işlenmesine ilişkin kapsamlı bilgilendirmeyi içermektedir.",
      ]},
      { heading: "İşlenen Kişisel Veri Kategorileri", paragraphs: ["Şirket faaliyetleri kapsamında aşağıdaki kişisel veri kategorileri işlenebilmektedir:"],
        list: ["Kimlik Bilgileri", "İletişim Bilgileri", "Finansal Bilgiler", "Müşteri İşlem Bilgileri", "Teknik Servis ve Destek Kayıtları", "Elektronik İşlem Verileri (IP, log kayıtları vb.)", "Sözleşme ve Fatura Bilgileri"],
      },
      { heading: "Kişisel Verilerin İşlenme Amaçları", paragraphs: ["Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:"],
        list: [
          "Ürün ve hizmetlerin sunulması, geliştirilmesi ve yönetilmesi",
          "Teknik servis, bakım, destek ve kurulum süreçlerinin yürütülmesi",
          "Sunucu kiralama, VPN altyapısı ve güvenlik hizmetlerinin sağlanması",
          "Müşteri ilişkileri yönetimi ve iletişim faaliyetlerinin yürütülmesi",
          "Finans, muhasebe ve faturalama süreçlerinin yürütülmesi",
          "Sözleşme süreçlerinin yürütülmesi ve takibi",
          "Yasal yükümlülüklerin yerine getirilmesi",
          "Bilgi güvenliği süreçlerinin yürütülmesi ve log kayıtlarının tutulması",
        ],
      },
      { heading: "Kişisel Verilerin Aktarılması", paragraphs: [
        "Kişisel verileriniz, KVKK'nın 8. ve 9. maddeleri kapsamında; yetkili kamu kurum ve kuruluşlarına, iş ortaklarımıza ve tedarikçilerimize, hukuken yetkili kişi ve kuruluşlara, hizmet aldığımız veya hizmet sunduğumuz iş ortaklarına hukuki sınırlar çerçevesinde aktarılabilmektedir.",
      ]},
      { heading: "Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi", paragraphs: [
        "Kişisel verileriniz; web sitemiz, iletişim formlarımız, teknik servis süreçlerimiz, sözleşmeler, e-posta ve telefon iletişimi, sunucu kiralama ve VPN hizmeti kullanım kayıtları aracılığıyla toplanmaktadır.",
        "Verileriniz KVKK'nın 5. ve 6. maddelerinde belirtilen; kanunlarda öngörülmesi, sözleşmenin kurulması veya ifası, hukuki yükümlülüğün yerine getirilmesi, meşru menfaat ve açık rıza hukuki sebeplerine dayanarak işlenmektedir.",
      ]},
      { heading: "KVKK Kapsamındaki Haklarınız", paragraphs: [
        "KVKK'nın 11. maddesi uyarınca, kişisel verilerinizin işlenip işlenmediğini öğrenme, işlenmişse buna ilişkin bilgi talep etme, verilerinizin işlenme amacını ve bu amaçlara uygun kullanılıp kullanılmadığını öğrenme, yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme, eksik veya yanlış işlenmiş olması hâlinde düzeltilmesini talep etme, işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde silinmesini veya yok edilmesini isteme, bu işlemlerin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini talep etme, otomatik sistemler ile analiz edilmesi sonucu aleyhinize bir sonucun ortaya çıkması hâlinde buna itiraz etme ve kişisel verilerinizin hukuka aykırı olarak işlenmesi sebebiyle zarara uğramanız durumunda tazminat talep etme haklarına sahipsiniz.",
      ]},
      { heading: "Başvuru ve İletişim Kanalı", paragraphs: [
        "KVKK kapsamındaki tüm başvurularınızı, bilgi taleplerinizi ve kişisel verilerinizle ilgili haklarınıza yönelik iletilerinizi Pratik Bilişim Teknolojileri A.Ş.'nin resmî iletişim kanalı olan info@pratikteknoloji.tr adresine yazılı olarak iletebilirsiniz.",
        "Tarafımıza ulaşan başvurular; kimlik doğrulaması yapılarak, KVKK'nın 13. maddesi uyarınca en geç 30 gün içerisinde değerlendirilir ve sonuçlandırılır.",
      ]},
    ],
  },
  gizlilik: {
    title: "Gizlilik Politikası",
    desc: "Pratik Bilişim Teknolojileri A.Ş. Gizlilik Politikası.",
    sections: [
      { paragraphs: [
        "Pratik Bilişim Teknolojileri Anonim Şirketi olarak, kullanıcılarımızın gizliliğini ve kişisel verilerinin güvenliğini öncelikli ilke olarak benimsemekteyiz. Web sitemizi ziyaret ettiğinizde veya hizmetlerimizi kullandığınızda paylaştığınız bilgiler, yalnızca ilgili hizmetlerin sunulması amacıyla işlenmekte ve korunmaktadır.",
      ]},
      { heading: "Toplanan Bilgiler", list: [
        "İletişim ve talep formları",
        "Teknik servis ve destek kayıtları",
        "Sunucu kiralama ve VPN hizmeti kullanım verileri",
        "Trafik ve log kayıtları",
        "Çerez verileri",
      ]},
      { heading: "Bilgilerin Kullanım Amaçları", paragraphs: ["Toplanan bilgiler yalnızca:"], list: [
        "Hizmet sunumu",
        "Teknik destek",
        "Müşteri iletişimi",
        "Güvenlik süreçlerinin yürütülmesi",
        "Yasal yükümlülüklerin yerine getirilmesi",
      ], },
      { heading: "Veri Güvenliği", paragraphs: ["Verileriniz; güvenli sunucularda, kapalı devre VPN altyapısında, yetkisiz erişime karşı korumalı sistemlerde saklanmaktadır."] },
    ],
  },
  cerez: {
    title: "Çerez Politikası",
    desc: "Pratik Bilişim Teknolojileri A.Ş. Çerez Politikası.",
    sections: [
      { paragraphs: ["Web sitemizde kullanıcı deneyimini iyileştirmek, performansı artırmak ve ziyaretçi trafiğini analiz etmek amacıyla çerezler kullanılmaktadır."] },
      { heading: "Kullanılan Çerez Türleri", list: ["Zorunlu çerezler", "Performans çerezleri", "Analitik çerezler", "İşlevsel çerezler"] },
      { heading: "Çerezlerin Kullanım Amaçları", list: ["Site performansını artırmak", "Trafik analizi yapmak", "Kullanıcı deneyimini geliştirmek", "Güvenlik kontrolleri sağlamak"] },
      { heading: "Çerez Yönetimi", paragraphs: ["Tarayıcı ayarlarınızdan çerezleri dilediğiniz zaman yönetebilir veya devre dışı bırakabilirsiniz."] },
    ],
  },
};
